import { SelectItem } from "@/shared/components/ui/select";
import { RAID_ROLE_ICONS } from "@/shared/lib/roleIcons";
import { RAID_ROLE_LABELS, RAID_ROLES } from "@/shared/lib/roles";

// Option rows for a raid-role <Select> — icon + label, shared by roster and setup.
export function RaidRoleSelectItems() {
  return (
    <>
      {RAID_ROLES.map((r) => {
        const Icon = RAID_ROLE_ICONS[r];
        return (
          <SelectItem key={r} value={r}>
            <Icon />
            {RAID_ROLE_LABELS[r]}
          </SelectItem>
        );
      })}
    </>
  );
}
